import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Filter } from 'iconsax-react';
import Button from '@/components/atoms/Button';
import Search from '@/components/categories/Search';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';

export const LogsTableFilters: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { modalExtraData } = usePublicState();

  return (
    <div
      className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto"
      data-testid="config-logs-table-filters"
    >
      <Search
        searchName="configLogs"
        inputWidth="w-full sm:w-64 lg:w-80"
        placeholder={t('home.searchHere')}
        data-testid="config-logs-search-input"
      />
      <Button
        size="md"
        className="!rounded-xl !border-light-input-border !px-4 !py-3 !gap-2.5 !bg-white !text-light-text-primary whitespace-nowrap w-full sm:w-auto justify-center"
        variant="outline"
        icon={
          <Filter
            size={18}
            variant="Outline"
            className="text-light-text-primary dark:text-white"
          />
        }
        onClick={() =>
          dispatch(
            setModalId({
              id: 'CONFIG_LOGS_FILTERS',
              extraData: modalExtraData,
            })
          )
        }
        data-testid="config-logs-filter-btn"
      >
        {t('product.filterBtn')}
      </Button>
    </div>
  );
};

export default LogsTableFilters;
